import React, { useState, useEffect } from 'react';
import { Tree } from 'primereact/tree';
import { NodeService } from './NodeServer';

export default function TaskList() {
    const [nodes, setNodes] = useState([]);
    useEffect(() => {
        NodeService.getTreeNodes().then((data) => setNodes(data));
    }, []);
  
    

    return (
        <div className="container">
            <Tree value={nodes} dragdropScope="demo" onDragDrop={(e) => setNodes(e.value)} className="w-full md:w-30rem" />
        </div>
    )
}        


